import { problemText, useApiProblem } from '@/shared/api';
import { Button } from '@/shared/components';

/** Nachladen schlug fehl, der letzte Stand bleibt stehen – mit Hinweis statt still veraltet. */
export function StaleNote({ onRetry }: { onRetry: () => void }) {
  return (
    <p role="status" className="text-ink-soft flex flex-wrap items-center gap-x-3 text-xs">
      Nachladen fehlgeschlagen – angezeigt wird der letzte Stand.
      <button type="button" onClick={onRetry} className="text-forest min-h-11 font-bold">
        Erneut laden
      </button>
    </p>
  );
}

/** Erstes Laden schlug fehl: Satz mit Grund und neuer Versuch – nie „noch keine“. */
export function LoadError({
  error,
  fallback,
  onRetry,
  retrying,
}: {
  error: unknown;
  fallback: string;
  onRetry: () => void;
  retrying: boolean;
}) {
  const problem = useApiProblem(error);
  return (
    <div role="alert" className="flex flex-wrap items-center gap-3 text-sm">
      <span className="min-w-0 flex-1">{problemText(problem, fallback)}</span>
      <Button variant="ghost" className="min-h-11" loading={retrying} onClick={onRetry}>
        Erneut laden
      </Button>
    </div>
  );
}
